import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import jwtDecode from "jwt-decode";
import facebookActions from "modules/facebook/actions";
import styled from "styled-components";
import facebookSelectors from "modules/facebook/selectors";
import Icon from "components/Icon";
import { useTranslation } from "react-i18next";
import { FacebookCircle } from "@styled-icons/boxicons-logos/FacebookCircle";
import LoadingContainer from "components/LoadingContainer";

const SigninButton = ({ mode, linkTitle, reload = null }) => {
  const rmpToken = sessionStorage.getItem("rmp_token");
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const getFacebookApiTokenResult = useSelector((state) => facebookSelectors.getFacebookApiTokenResult(state));
  const changeFacebookSettingPageResult = useSelector((state) => facebookSelectors.changeSettingPageResult(state));
  const { REACT_APP_FACEBOOK_APP_ID, REACT_APP_FACEBOOK_GRAPH_API_VERSION, REACT_APP_RMP_SALESDESK_API_URL } =
    process.env;
  const readyplanetEmailPattern = /^[A-Za-z0-9._%+-]+@readyplanet.com$/gi;
  let lang = sessionStorage.getItem("lang") ? sessionStorage.getItem("lang") : "en";
  let accessToken;
  let userInfo;
  let client;

  const [showLoadingContainer, setShowLoadingContainer] = useState(false);

  const setFacebookButton = () => {
    FB.getLoginStatus(function (response) {
      if (response.status == "connected") {
        FB.api("/me/?fields=id,first_name,picture", function (response) {
          $("#fb_button_text").text(label.label_continue_as + " " + response.first_name);
        });
        $("#fb_another_account_login_button").hide();
      } else {
        $("#fb_button_text").text(label.label_continue_as_facebook);
        $("#fb_another_account_login_button").hide();
      }
    });
  };

  const getFacebookApiToken = async (response) => {
    const result = await dispatch(
      facebookActions.getFacebookApiToken({
        token: rmpToken,
        access_token: response.authResponse.accessToken,
      }),
    );

    if (result.result === 0) {
      setShowLoadingContainer(false);

      if (changeFacebookSettingPageResult.data.page === "ads_setup") {
        if (typeof reload === "function") {
          reload();
        } else {
          dispatch(facebookActions.changeSettingPage("ads_setup"));
        }
      } else {
        dispatch(facebookActions.changeSettingPage("ads_setup"));
      }
    } else {
      // Permission or session invalid
      facebookReLogin();

      // setShowLoadingContainer(false)
    }
  };

  const facebookLogin = () => {
    setShowLoadingContainer(true);

    FB.getLoginStatus(function (response) {
      if (response.status == "connected") {
        getFacebookApiToken(response);
      } else {
        FB.login(
          function (response) {
            if (response.authResponse) {
              getFacebookApiToken(response);
              // setFacebookButton();
            } else {
              setShowLoadingContainer(false);
            }
          },
          {
            scope:
              "ads_management,ads_read,pages_show_list,business_management,catalog_management,pages_read_engagement",
            return_scopes: true,
          },
        );
      }
    });
  };

  const facebookReLogin = () => {
    setShowLoadingContainer(true);

    FB.getLoginStatus(function (response) {
      if (response.status === "connected") {
        FB.logout(function (response) {
          facebookLogin();
        });
      }
    });
  };

  return (
    <>
      <StyledFacebookButton onClick={reload && reload !== "" ? facebookReLogin : facebookLogin}>
        <i className="fab fa-facebook-square"></i>
        <span id="fb_button_text">
          <StyledFaceboolIcon />
          &nbsp;{t("__fbads_setup_facebook_login_button")}
        </span>
        <LoadingContainer show={showLoadingContainer} borderRadius={10} />
      </StyledFacebookButton>
    </>
  );
};

const StyledFacebookButton = styled.button`
  color: #fff;
  background-color: #1578f1;
  border: none;
  border-radius: 4px;
  padding: 5px 20px;
  cursor: pointer;
`;

const AuthDummyButton = styled.div`
  z-index: 1;
  position: absolute;
  width: 250px;
  height: 44px;
  cursor: pointer;
`;

const SigninButtonContainer = styled.div`
  position: relative;

  @media screen and (max-width: 834px) {
    display: flex;
    justify-content: center;
  }
`;

const Link = styled.span`
  cursor: pointer;
  color: #337ab7;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const StyledFaceboolIcon = styled(FacebookCircle)`
  width: 25px;
`;

export default SigninButton;
